export default __webpack_public_path__ + "static/media/notes-science-svgrepo-com.01d13b38.svg";